import React from 'react'
import TabNavigation from '../../../components/TabNavigation'
import { usePathUrlMatcher } from '../../../utils/hooks'

export const tabs = [
	{ title: "Mes noms de domaine", href: '/websites', disabled: false },
	{ title: "Mes autres supports de communication", href: "/websites/com-supports", disabled: false },
	{ title: "Mes concurrents", href: "/websites/concurrents", disabled: false },
	{ title: "Mes connexions", href: '/websites/connexions', disabled: false },
	{ title: "Mes informations d'activité", href: '/websites/quiz', disabled: false },
]

const Websites = () => {
	return (
		<>
			<TabNavigation tabs={tabs} />
			{usePathUrlMatcher()}
		</>
	)
}

export default Websites